module.exports = __webpack_public_path__ + "img/cww_03.d87d3e57.jpg";